import {
  Box,
  Button,
  List,
  ListItem,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import styles from "../../styles/pages/superadmin/message-details.module.scss";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import AttachFiles from "../AttachFiles/AttachFiles.jsx";
import AgentTagList from "../AgentTagList/AgentTagList";
import MessageStatus from "../MessageStatus/MessageStatus";
import MessagePageLeftHeading from "../MessagePageLeftHeading/MessagePageLeftHeading";
import MessageDetailsRightPanel from "../MessageDetailsRightPanel/MessageDetailsRightPanel";
import { getCookie } from "../../lib/functions/storage.lib";
import axiosInstance from "../../api/axiosInstance";
import {
  getAbsoluteImageURI,
  getStyledDateTime,
} from "../../lib/functions/utils.lib";
import { useNavigate } from "react-router";
import SuperAdminMessageVideoModal from "../VideoPages/pages/SuperAdminMessageVideoModal";

const MessageDetailsCard = (props) => {
  const updateInquiry = async (params) => {
    const { data } = await axiosInstance.post("update-inquery", {
      ...params,
      inquery_id: props?.message?.id,
    });
    props.refetchMessageData();
    return data;
  };
  const userCookie = getCookie("userdetails");
  const user = JSON.parse(userCookie ? userCookie : "{}");

  const resolveInquiry = () => {
    updateInquiry({
      status: 1,
    });
  };
  const adminJoin = () => {
    updateInquiry({
      admin_joined: 1,
    });
  };
  const openInquiry = () => {
    updateInquiry({
      status: 0,
    });
  };
  const archiveInquiry = () => {
    updateInquiry({
      archive: 1,
    });
  };
  const getStatus = (inquiry) => {
    if (!inquiry?.status) {
      if (inquiry?.video) {
        if (user?.id !== inquiry?.last_message?.sender?.id)
          return {
            name: "Awaiting your reply",
            class: `${styles.noNeed} ${styles.statusTxt}`,
          };
      }
      return {
        name: inquiry?.video ? "Awaiting recipient’s reply" : "Pending",
        class: `${styles.pending} ${styles.statusTxt} ${styles.btnYlwWarning}`,
      };
    }
    return {
      name: inquiry?.video ? "Closed" : "Resolved",
      class: `${styles.approved} ${styles.statusTxt} ${styles.btngrnResolve}`,
    };
  };
  const [respondToInquiry, setRespondToInquiry] = useState(false);

  const toggleRepondToInquiry = () => {
    setRespondToInquiry((prev) => !prev);
  };
  const navigate = useNavigate();

  const [openModal, setOpenModal] = useState(false);
  const [id, setId] = useState();

  const onOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const onClose = () => {
    setId();
    setOpenModal(false);
    // handleTriggreFetch();
  };

  // const [scrolled, setScrolled]
  //   const scrollbarRef = useRef(null);

  //   useEffect(() => {
  //     const ps = scrollbarRef.current;

  //     if (ps) {
  //       // Get the current position of the scrollbar
  //       const scrollTop = ps;
  //       console.warn(scrollTop);
  //     }
  //   }, []);

  const [scroll, setScroll] = useState(0);
  const onScroll = () => {
    const scrollTop = document.getElementById("test").scrollTop;
    console.log("scroll", scrollTop);
    setScroll(scrollTop);
  };
  const [scroll2, setScroll2] = useState(0);
  const onScroll2 = () => {
    const scrollTop = document.getElementById("test2").scrollTop;

    setScroll2(scrollTop);
  };

  return (
    <>
      <MessagePageLeftHeading
        scroll={scroll}
        scroll2={scroll2}
        headingText={
          props?.message?.video
            ? "Message Details"
            : `Ticket Details (#SR${props?.message?.id})`
        }
        back_support={props?.message?.video ? true : false}
      />
      {/* <PerfectScrollbar
        className={styles.scrollbarDetails}
        // ref={scrollbarRef}
        // onScrollY={(e) => console.warn(e)}
        id="test"
        onScroll={onScroll}
      > */}
      <Stack direction="row" flexWrap="wrap" className={styles.msgColumn}>
        <Box className={`${styles.detailsColLeft} ${scroll > 260 ? styles.scroll_header : scroll < 60 ? "" : ""}`} >
          <PerfectScrollbar
            className={styles.scrollbarDetails}
            id="test"
            onScroll={onScroll}
          >
            <Stack justifyContent="space-between" sx={{ height: "100%" }}>
              <Box>
                <Box className={styles.msgdetails}>
                  <Paper
                    className={`${styles.styledPaper} ${styles.forMsgDetails} ${
                      props?.message?.video ? "" : styles.forTicketDetails
                    }`}
                  >
                    {props?.message?.video ? (
                      <>
                        <figure>
                          <img
                            src={getAbsoluteImageURI(
                              props?.message?.video?.thumbnail
                            )}
                            width={374}
                            height={174}
                            alt="image"
                          />
                        </figure>
                        <Box className={styles.papperBottomDetails}>
                          <Box className={styles.sideGapWrap}>
                            <Typography variant="body1">
                              {props?.message?.video?.title
                                ? props?.message?.video?.title
                                : "N/A"}
                            </Typography>
                            <Stack
                              direction="row"
                              alignItems="center"
                              justifyContent="space-between"
                              flexWrap="wrap"
                              className={styles.codeStack}
                            >
                              <Typography variant="body2">
                                VSID:{" "}
                                <span>
                                  #
                                  {props?.message?.video?.id
                                    ? props?.message?.video?.id
                                    : "N/A"}
                                </span>
                              </Typography>
                              <Button
                                onClick={() =>
                                  onOpen(props?.message?.video?.id)
                                }
                              >
                                More details
                              </Button>
                            </Stack>
                          </Box>
                          <Box
                            className={`${styles.createdDate} ${styles.sideGapWrap}`}
                          >
                            <Typography variant="caption">
                              Created on:
                            </Typography>
                            <Typography variant="body1">
                              {props?.message?.created
                                ? getStyledDateTime(props?.message?.created)
                                : "N/A"}
                            </Typography>
                          </Box>
                        </Box>
                      </>
                    ) : (
                      <>
                        <List>
                          <ListItem>
                            <Typography variant="caption">Subject</Typography>
                            <Typography variant="body1">
                              {props?.message?.subject}
                            </Typography>
                          </ListItem>
                          <ListItem>
                            <Typography variant="caption">
                              Created on
                            </Typography>
                            <Typography variant="body1">
                              {getStyledDateTime(props?.message?.created)}
                            </Typography>
                          </ListItem>
                          <ListItem>
                            <Typography variant="caption">
                              Last updated
                            </Typography>
                            <Typography variant="body1">
                              {getStyledDateTime(props?.message?.created)}
                            </Typography>
                          </ListItem>
                          <ListItem>
                            <Typography variant="caption">Sender</Typography>
                            <Typography variant="body1">
                              {props?.message?.initiated?.name}(
                              {props?.message?.initiated?.role?.display_name})
                            </Typography>
                          </ListItem>
                        </List>
                        <Stack
                          direction="row"
                          alignItems="center"
                          className={styles.secPriority}
                        >
                          <Typography variant="overline">Priority:</Typography>

                          {/* =========== PRIORITY BUTTONS START ============ */}
                          {props?.message?.priority?.toString() ? (
                            props?.message?.priority === 0 ? (
                              <Typography
                                variant="caption"
                                className={styles.priorityLow}
                              >
                                Low{" "}
                              </Typography>
                            ) : props?.message?.priority === 1 ? (
                              <Typography
                                variant="caption"
                                className={styles.priorityMedium}
                              >
                                Medium
                              </Typography>
                            ) : props?.message?.priority === 2 ? (
                              <Typography
                                variant="caption"
                                className={styles.priorityHigh}
                              >
                                High
                              </Typography>
                            ) : (
                              <Typography
                                variant="caption"
                                className={styles.priorityCritical}
                              >
                                Critical
                              </Typography>
                            )
                          ) : (
                            <Typography
                              variant="caption"
                              className={styles.priorityLow}
                            >
                              Low
                            </Typography>
                          )}

                          {/* =========== PRIORITY BUTTONS END== ============ */}
                        </Stack>
                      </>
                    )}
                  </Paper>
                </Box>
                <AttachFiles attachments={props?.message?.attachments} />
                {props?.message?.video ? (
                  <AgentTagList
                    initiated={props.message?.initiated}
                    recipent={props.message?.recipent}
                    admin_joined={props.message?.admin_joined}
                    admin_joined_at={props.message?.admin_joined_at}
                  />
                ) : (
                  ""
                )}
              </Box>
              {props?.message?.admin_joined ? (
                <Box>
                  <MessageStatus
                    archived={props?.message?.archive}
                    iquiry_video={props?.message?.video}
                    status={getStatus(props?.message)}
                    resolved_by={props?.message?.resolved_by}
                    resolved_at={getStyledDateTime(props?.message?.resolved_at)}
                    mark_resolved={resolveInquiry}
                    open_inquiry={openInquiry}
                    archive_inquiry={archiveInquiry}
                    respondToInquiry={respondToInquiry}
                    setRespondToInquiry={setRespondToInquiry}
                  />
                </Box>
              ) : (
                ""
              )}
            </Stack>
          </PerfectScrollbar>
        </Box>
        <MessageDetailsRightPanel
          inquiry={props?.message}
          status={getStatus(props?.message)}
          resolve_inquiry={resolveInquiry}
          open_inquiry={openInquiry}
          admin_join={adminJoin}
          respondToInquiry={respondToInquiry}
          toggleRepondToInquiry={toggleRepondToInquiry}
          onScroll={onScroll2}
          id={"test2"}
        />
        <SuperAdminMessageVideoModal
          onClose={onClose}
          open={openModal}
          id={id}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="videoPageModal"
        />
      </Stack>
      {/* </PerfectScrollbar> */}
    </>
  );
};

export default MessageDetailsCard;
